import { selectActApiUrl } from 'util/selector/apiSelector';

import axios, { AxiosInstance } from 'axios';
import Cookies from 'universal-cookie';
import { AUTH_TOKEN_COOKIE } from 'shared/constants/cookies';

export const actClient: AxiosInstance = axios.create({
  baseURL: selectActApiUrl(),
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'en-GB',
    Accept: 'application/json',
  },
});

actClient.interceptors.request.use((config) => {
  const authToken = new Cookies().get(AUTH_TOKEN_COOKIE);

  if (authToken && config.headers) {
    config.headers['Authorization'] = `Bearer ${authToken}`;
  }

  return config;
});
